export const environment = {
  isLocal: false,
  BASE_URL: '#{apiBaseUrl}#',
  AUTH_CONFIG: {
    auth: {
      clientId: '#{clientID}#',
      authority: '#{authority}#',
      redirectUri: '#{redirectUri}#',
      postLogoutRedirectUri: '#{postLogoutRedirectUrl}#',
    },
    cache: {
      cacheLocation: 'sessionStorage', //BrowserCacheLocation.LocalStorage,
      // storeAuthStateInCookie: isIE, // set to true for IE 11. Remove this line to use Angular Universal
    },
  },
  LOCAL_AUTH: {
    userId: 'systemuser@deloitte.com',
    userName: 'System User',
  },
  AUTH_RESOURCE_LINK: {
    self: 'https://graph.microsoft.com/v1.0/me',
    users: 'https://graph.microsoft.com/v1.0/users',
  },

  API_CONFIG_SCOPE: ['user.read'],
  GRAPH_URL: 'graph.microsoft.com',
  ALLOWEDDOMAINS: ['deloitte', 'deloittece', 'deloittemx'],
  COOKIE_CONSENT_KEY: '#{cookieConsent}#',
  ADOBE_ANALYTICS: '#{adobeAnalytics}#',
  IS_ADOBE_ANALYTICS_ENABLED: "#{isAdobeAnalyticsEnabled}",
  WEBSOCKET_URL :'#{websocketUrl}#',
  pollingDuration: 10000,
  FILE_SCAN_CONTAINER : "use-azs-cms-ascend-file-scan",
  APPLICATIONINSIGHTS_CONNECTION_STRING:'#{appInsightsConnectionString}#',
  APPINSIGHTS_INSTRUMENTATIONKEY:'#{appInsightsInstrumentationKey}#',
  RSA_PUBLIC_KEY: '#{rsaPublicKey}#',
  TRAINING_COURSE_LINK: '#{trainingCourseLink}#',
  PRIVACY_POLICY_LINK: '#{privacyPolicyLink}#'
};
